import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface StopsIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function StopsIcon({ color = RoutalPalette.neutral00, style = {} }: StopsIconProps) {
  return (
    <SvgIcon width="17" height="17" viewBox="0 0 17 17" style={{ ...style }}>
      <path
        d="M14.7132 4.48763C14.3772 3.79963 13.8972 3.19163 13.2892 2.66363C12.6732 2.13563 11.9532 1.72763 11.1532 1.44763C10.3452 1.15963 9.4972 1.01562 8.6252 1.01562C6.8652 1.01562 5.2092 1.59962 3.9612 2.66363C2.7212 3.72763 2.0332 5.13562 2.0332 6.63163C2.0332 8.82363 3.0412 11.1516 5.0412 13.5436C5.6732 14.2956 6.7212 15.4476 8.1692 16.6156L8.2412 16.6716C8.3532 16.7516 8.4892 16.7916 8.6332 16.7916C8.7772 16.7916 8.8972 16.7516 9.0412 16.6556C9.0412 16.6556 10.6492 15.4556 12.2332 13.5516C14.1932 11.1916 15.2252 8.79963 15.2252 6.63963C15.2252 5.89563 15.0572 5.17563 14.7212 4.48763H14.7132ZM10.3372 7.24762C9.7452 7.51963 9.2652 7.99963 8.9932 8.58363L8.6332 9.35962L8.2732 8.58363C8.0012 7.99963 7.5212 7.51963 6.9292 7.24762L6.1452 6.88763L6.9292 6.52763C7.5212 6.25563 8.0012 5.77563 8.2732 5.19163L8.6332 4.41563L8.9932 5.19163C9.2652 5.77563 9.7452 6.25563 10.3372 6.52763L11.1212 6.88763L10.3372 7.24762Z"
        fill={color}
      />
    </SvgIcon>
  );
}
